<template>
<div>
    
  <el-dialog
    title="购卡"
    :visible.sync="dialog"
    width="40%" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form inline v-if="userinfo">
        <el-form-item label="应付金额:">
          <div class="yingfu" v-if="userinfo.role==3">
            ￥{{form.num * userinfo.vip_price * userinfo.daili_zhekou / 10}}
            <span style="color: #515151;text-decoration: line-through;font-weight: normal;font-size:16px;">￥{{form.num * userinfo.vip_price}}</span>
          </div>
          <div class="yingfu" v-if="userinfo.role!=3">
            <div v-if="form.num<3">
              ￥{{form.num * userinfo.vip_price}}
            </div>
            <div v-if="form.num>=3 && form.num<=5">
              ￥{{form.num * userinfo.vip_price * userinfo.san_zhekou / 10}}
              <span style="color: #515151;text-decoration: line-through;font-weight: normal;font-size:16px;">￥{{form.num * userinfo.vip_price}}</span>
            </div>
            <div v-if="form.num>=6">
              ￥{{form.num * userinfo.vip_price * userinfo.liu_zhekou / 10}}
              <span style="color: #515151;text-decoration: line-through;font-weight: normal;font-size:16px;">￥{{form.num * userinfo.vip_price}}</span>
            </div>
          </div>
        </el-form-item>
              <br/>
        <el-form-item label="购卡数量:">
          <el-input-number v-model="form.num" @change="goukaNumber" :min="1" :max="9999" label="购卡数量"></el-input-number>
        </el-form-item>
        <br/>
        <el-form-item label="支付方式:">
          <el-radio-group v-model="pay_type" type="success">
              <el-radio-button label="1">微信支付</el-radio-button>
              <el-radio-button label="2">支付宝支付</el-radio-button>
            </el-radio-group>
        </el-form-item>
        <br/>
        <el-form-item label="优惠说明:">
          <div v-if="userinfo.role!=3">3-5张<span style="color: red;">{{userinfo.san_zhekou}}</span>折、6-9张<span style="color: red;">{{userinfo.liu_zhekou}}</span>折</div>
          <div v-if="userinfo.role==3">代理：<span style="color: red;">{{userinfo.daili_zhekou}}</span>折</div>
        </el-form-item>
      </el-form>
      <div class="pay" v-loading="loading">
        <div class="item" v-if="pay_type==1">
          <div class="qrcode-img" id="qrCode" ref="qrCodeDiv">

          </div>
          <div class="weixin">
            <img src="@/assets/weixin.png" alt="">
            微信支付
          </div>
        </div>
  <!--     <div class="item" style="margin-left: 80px;" v-if="pay_type==2">
          <div class="weixin">
            <img src="@/assets/zhifubao.png" alt="">
            支付宝支付
          </div>
        </div> -->
      </div>
      <div style="width: 100%;display: flex;align-items: center;justify-content: center;margin-top:50px;">
        <el-button type="success" style="width: 100px;height: 40px;" @click="successPay()">支付完成</el-button>
        <el-button type="info" style="width: 100px;height: 40px;" @click="dialog=false">取消支付</el-button>
      </div>

      <!--支付宝支付-->
      <el-dialog title="支付宝支付" width="60%" :visible.sync="aliDia" top="2vh" append-to-body>
        <div style="width: 100%;height: 600px;">
          <iframe :src="wxForm.code_url" width="100%" height="100%" frameborder="0"></iframe>
        </div>
        <div style="width: 100%;display: flex;align-items: center;justify-content: center;margin-top:50px;">
          <el-button type="success" style="width: 100px;height: 40px;" @click="successPay()">支付完成</el-button>
          <el-button type="info" style="width: 100px;height: 40px;" @click="aliDia=false">取消支付</el-button>
        </div>
      </el-dialog>
      <!--支付宝支付-->
      
  </el-dialog>
  <!--购卡记录-->
  <goukaVue ref="goukaData" />
  <!--购卡记录-->

</div>
</template>

<script>
  import {mapGetters} from "vuex"
  import QRCode from 'qrcodejs2';
  import goukaVue from "./son/gouka.vue"
  import { pc_create_order,lunWxPayorder,aliPay_create_order } from "@/api/gw/pay.js"
  export default {
    computed:{
      ...mapGetters(['isLogin',"userinfo"]),
    },
    components:{
       goukaVue
    },
    data(){
      return{
        dialog:false,
        loading:false,
        aliDia:false,
        form:{
          num:1,//购卡数量
        },
        price:0,//支付金额

        wxForm:{
          code_url:"",//微信支付的url链接
          vippay_id:"",//微信支付记录ID
        },
        Wxtimer:null,//微信定时器
        renderedHtml:"",

        pay_type:"1",//支付方式  1微信支付  2支付宝支付
      }
    },
    props:{

    },
    watch:{
       dialog(e){
         if(e==false){
           clearInterval(this.Wxtimer);
           this.reset();
         }
       },
       pay_type(e){
         if(e==2){
           this.aliPay_create_order();
         }else{

         }
       },
       aliDia(e){
         if(e==false){
           clearInterval(this.Wxtimer);
           this.pay_type = 1
           this.pc_create_order();
         }
       },
    },
    mounted(){
       // this.$nextTick(()=>{
       //   this.pc_create_order();
       // });
    },
    methods:{
       show(){
         this.$nextTick(()=>{
           this.dialog = true
           this.$store.dispatch("getUserInfo").then(()=>{
             this.pc_create_order();
           })
           // this.aliPay_create_order();
         })
       },
       aliPay_create_order(){
         this.loaidng = true
         if(this.Wxtimer){
           clearInterval(this.Wxtimer);
         }
         aliPay_create_order({num:this.form.num}).then(res=>{
           console.log("支付宝支付",res.data);
           this.wxForm = res.data
           this.aliDia = true
           this.Wxtimer = setInterval(()=>{
             this.lunxun();
           },1000)
         }).finally(()=>{
           this.loading = false
         })
       },
       pc_create_order(){
         this.loading = true
         pc_create_order({
           num:this.form.num
         }).then(res=>{
            this.wxForm = res.data
            document.getElementById('qrCode').textContent = '';
            //此时进行定时器更新查询支付状态
             new QRCode(this.$refs.qrCodeDiv, {
                text: res.data.code_url,
                width: 198,
                height: 198,
                colorDark: "#333333", //二维码颜色
                colorLight: "#ffffff", //二维码背景色
                correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
              })
              this.Wxtimer = setInterval(()=>{
                this.lunxun();
              },1000)
         }).finally(()=>{
           this.loading = false
         })
       },
       lunxun(){
         if(!this.wxForm.vippay_id || this.dialog==false){
           clearInterval(this.Wxtimer);
           return;
         }
         lunWxPayorder({
           vippay_id:this.wxForm.vippay_id
         }).then(lun=>{
           if(lun.data.pay_status==2){
             clearInterval(this.Wxtimer);
            //  this.$message.success("支付成功，请点击’购卡记录‘进行查看");
             this.aliDia = false
             this.dialog = false
             this.$refs.goukaData.show()
           }
           if(this.dialog==false){
             clearInterval(this.Wxtimer)
           }
         }).catch(()=>{
           clearInterval(this.Wxtimer)
         })
       },
       //完成支付
       successPay(){
         this.loading = true
         lunWxPayorder({
           vippay_id:this.wxForm.vippay_id
         }).then(lun=>{
           if(lun.data.pay_status==2){
             clearInterval(this.Wxtimer);
            //  this.$message.success("支付成功，请点击’购卡记录‘进行查看");
             this.aliDia = false
             this.dialog = false
             this.$refs.goukaData.show()
           }else{
             this.$message.error("您还未完成支付");
           }
         }).finally(()=>{
           this.loading = false
         })
       },
       goukaNumber(e){
         this.pc_create_order();
       },
       //重置
       reset(){
         clearInterval(this.Wxtimer);
         this.price = 0
         this.pay_type=1
         this.wxForm = {
           code_url:"",
           vippay_id:""
         };
       },
    },
  }
</script>

<style lang="scss" scoped>
  .pay{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
    .item{
      width: 198px;
    }
    .weixin{
      width: 198px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      margin-top: 12px;
      img{
        width:18px;
        height: 18px;
        margin-right: 10px;
      }
    }
    .qrcode-img{
      width: 198px;
      height: 198px;
      // border: 1px solid #4BB316;
      display: flex;
      align-items: center;
      justify-items: center;
      img{
        width: 100%!important;
        height: 100%!important;
        border-radius: 10px!important;
      }
    }
  }
.yingfu{
  font-size: 30px;
      font-weight: bold;
      color: #FF5216;
      margin-right: 5px;
      line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/payCard.vue